import { schemeBlues } from "d3-scale-chromatic";
import { scaleOrdinal } from "d3-scale";

const createColorScale = ({ domain }) => {
  /**
   * Creates an ordinal color scale that's good for named categories of data.
   *
   * @param domain: Arr of strs. Named categories.
   */

  const colorScale = scaleOrdinal()
    .domain(domain)
    .range(["#e5e5e5", "#fdba35", "#FC2D31"]);

  return colorScale;
};

export default createColorScale;
